// extracted by mini-css-extract-plugin
export default {"bannerBody":"_3RCJq","text":"-RSkx","cta":"_39ORv","searchFadeIn":"_2vnXQ"};